import * as _ from 'lodash';
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '..';
import { IBaseResponse } from '@nkr/models/index';
import { ICryoShipmentsPending } from '@nkr/models/index';
import { IDonorInfoForCryo } from '@nkr/models/index';

export interface ICryoShipmentsPendingResponse {
    data: {
        success: boolean,
        results: ICryoShipmentsPending[]
    }
}

export interface IDonorInfoForCryoResponse {
    data: {
        success: boolean,
        results: IDonorInfoForCryo
    }
}
export const ActionCreators = {
    getCryoShipmentsPending: () => (dispatch: Dispatch<IApplicationState>): Promise<ICryoShipmentsPendingResponse> => {
        var options = {
            url: __API__ + '/nkr-lab/get-pending-shipments'
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ICryoShipmentsPendingResponse) => {
            return Promise.resolve(response);
        });
    },
    markCryoShipped: (data: { xmTrackingId: number, trackingNumber: string }[]) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + '/nkr-lab/mark-cryo-shipped',
            data
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    createHistoHlaOrder: (donorId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + `/nkr-lab/${donorId}/create-histo-hla-order`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    updateCryoVials: (cryoCount: number, donorId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + `/nkr-lab/${donorId}/update-cryo-vials/${cryoCount}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    markCryoReceived: (donorId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + `/nkr-lab/${donorId}/mark-kit-received`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    getDonorForCryoManagement: (donorAlias: string) => (dispatch: Dispatch<IApplicationState>): Promise<IDonorInfoForCryoResponse> => {
        var options = {
            url: __API__ + `/nkr-lab/${donorAlias}/get-donor-for-cryo-management`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IDonorInfoForCryoResponse) => {
            return Promise.resolve(response);
        });
    }

};
